import React, { useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { PrimaryButton } from '@/styles/blocks';
import { FILTERS } from './constants';

function Footer({ state, loading, callbacks }) {
    const { status } = state?.filter || {};
    const [hasSelected, hasPermissions] = useMemo(() => {
        return [state.selectedObj.length > 0, state.selectedObj.every((invoice) => invoice.type === 'INTERNAL')];
    }, [state.selectedObj]);
    const { exportCsv, setApproved, setPaid } = callbacks;

    return (
        <>
            <Grid
                container
                css={css`
                    padding: 1rem;
                    background-color: white;
                    justify-content: center;
                    align-items: center;
                `}
            >
                <Grid
                    item
                    css={css`
                        margin-right: 16px;
                    `}
                >
                    <PrimaryButton onClick={exportCsv} disabled={!hasSelected}>
                        Export
                    </PrimaryButton>
                </Grid>
                {status === FILTERS.NOT_PAID && (
                    <Grid
                        item
                        css={css`
                            margin-right: 16px;
                        `}
                    >
                        <PrimaryButton
                            loading={loading.update}
                            onClick={setApproved}
                            disabled={!hasSelected || !hasPermissions}
                        >
                            Approve
                        </PrimaryButton>
                    </Grid>
                )}
                {status === FILTERS.APPROVED && (
                    <Grid
                        item
                        css={css`
                            margin-right: 16px;
                        `}
                    >
                        <PrimaryButton
                            loading={loading.update}
                            onClick={setPaid}
                            disabled={!hasSelected || !hasPermissions}
                        >
                            Mark as Paid
                        </PrimaryButton>
                    </Grid>
                )}
            </Grid>
        </>
    );
}

export default React.memo(Footer);
